import Component from 'vue-class-component';
import moduleStore from './store/searchSpeaker';
import Vue from 'vue';
import PageState from '../textToVideo/store/state';
import infiniteScroll from '@/components/infinite-scroll';
import SpeakerCards from './components/speakerCards/speakerCards';
import SearchByname from './components/searchByname/searchByname';
import { Prop } from 'vue-property-decorator';
import { getQueryString } from '@/utils/location';
import { judgeDeviceType } from "@/utils/device"
import SpeakerInfo from './components/speakerInfo/speakerInfo';
// import { MAudio } from "@/utils/audio";
@Component({
  name: 'searchSpeaker',
  components: {
    SpeakerCards,
    SearchByname,
    SpeakerInfo
  },
  directives: { infiniteScroll },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible: {
      handler(newVal) {
        this.show = newVal;
      },
    },
  },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class searchSpeakerPage extends Vue implements IvuePage<PageState> {
  // 判断是/否是 app 页面
  isApp = judgeDeviceType.isAPP

  pageSource = '';
  state = new PageState();
  self: Vue = this;
  show = true; //当前页面显示/隐藏
  keyWord = '';
  allTagsList = [];
  speakerResults = []; //根据条件筛选出来的发音人
  pageSize = 16;
  pageNum = 1;
  totalPages = 1;
  totalElements = 0; //所有发音人个数
  // 需要过滤掉的音色名称（本体名）
  FILTER_SPEAKER_NAMES = ['魔大佐', '魔太君', '魔大佐Pro'];
  hiddenSpeakerCount = 0; //被过滤掉的发音人累计数量

  morePull = require('/public/images/video_editor/more_pull.png');
  morePullRed = require('/public/images/video_editor/more_pull_red.png');
  moreUp = require('/public/images/video_editor/more_up.png');
  newYearPull = require('/public/images/migu/more_pull_new_year.png');
  newYearUp = require('/public/images/migu/more_up_new_year.png');
  selectTypeInfo = {
    //所有选择的查询条件value
    domainId: '',
    specificLanguage: '',
    gender: '',
    favourite: '',
    age: '',
  };
  selectTypeInfoTxt = {
    //所有选择的查询条件name
    domainId: '',
    specificLanguage: '',
    gender: '',
    favourite: '',
    age: '',
  };
  currSelectIndex = null; //当前展开的选择条件下标
  currentClickIndx = null;
  isAudioListing = false; //是否在试听发音人
  showSearchByName = false;
  currSpeaker = null; //当前选择的发音人
  selectSpeakerName = null; //当前选择的发音人(本体)
  allSpeakersMap = null; //处理后的发音人
  emotionListMap = null; //所有风格
  newYearEmotionListMap = null // 风格列表
  theme = ''; // 主题
  querySpeakerInfo:any = {} // 路由传递过来的发音人信息
  isMigu = false;
  async mounted() {
    console.log('---mounted', this.state);
    this.getRouteParams()
    let selectSpeakerName = getQueryString('selectSpeakerName');
    this.selectSpeakerName = selectSpeakerName; //根据传入的默认发音人Id查找当前发音人
    this._getSpeakerEmotionList();
    this.getStoreSearchCriteriaFn();
    this.getSpeakerBySearchFn();
    this.getCachedResult();
  }
  getRouteParams() {
    const query:any = this.$route.query;
    if (query.from && query.from.indexOf('migu') !== -1) {
      this.isMigu = true;
    }
    console.log('getRouteParams', query.from)
    const theme = query.theme || localStorage.getItem('theme') || '';
    this.theme = theme;
    this.querySpeakerInfo = {
      speakerName: query.speakerName,
      speakerStyle: query.speakerStyle,
      speechSpeed: query.speechSpeed,
      speakerId: query.speakerId
    }
    if (this.querySpeakerInfo.speakerName) {
      this.getSpeakerBySearchFn(false, this.querySpeakerInfo.speakerName)
    }
    
    console.log('querySpeakerInfo', this.querySpeakerInfo)
  }
  _getSpeakerEmotionList() {
    this.$http('getSpeakerEmotionList', {})
      .then(res => {
        if (res.code == 200) {
          this.newYearEmotionListMap = (res.data || []).reduce((target: any, item: any) => {
            target[item.emotion] = { imageUrl: item.imageUrl, emotionName: item.emotionName };
            return target;
          }, {})
        } 
      })
      .catch(err => {
        console.log(err);
      });
  }
  // 主题类名
  get themeClass() {
    console.log('themeClass', this.theme)
    if (this.theme === 'New_Year') {
      return 'new-year migu-search-speaker';
    }
    return '';
  }
  beforeDestroy() {
    this.cancelListen();
  }

  // 获取缓存数据
  getCachedResult() {
    const timer = setTimeout(() => {
      if(!this.speakerResults.length) {
        const results = JSON.parse(localStorage.getItem('speakerList'))
        if(results?.length) {
          this.speakerResults = this.filterSpeakerResults(results);
        }
      }
      clearTimeout(timer);
    }, 50)
  }

  // 过滤掉指定音色
  filterSpeakerResults(list: any[] = []): any[] {
    return list.filter(item => {
      const baseName = (item.name || '').split('|')[0];
      return !this.FILTER_SPEAKER_NAMES.includes(baseName);
    });
  }

  /**获取全部分类 */
  getStoreSearchCriteriaFn() {
    let allTagsList = []; //所有筛选条件
    //语言 //性别 //收藏
    this.$http('getStoreSearchCriteria').then(res => {
      if (res.code == 200) {
        let tagsData = res.data;
        if (tagsData) {
          let tagKeyList = Object.keys(tagsData);
          tagKeyList.forEach(val => {
            let [value, key] = val.split(':');
            value = value.substr(2);
            tagsData[val] = tagsData[val].map(item => {
              item.key = key;
              return item;
            });
            let obj: any = {};
            obj.name = value;
            obj.key = key;
            tagsData[val].unshift({ name: '全部', value: '', key });
            if (tagsData[val].length > 12) {
              obj.type = 'more';
              obj.moreCount = tagsData[val].length - 11;
            }
            obj.data = tagsData[val];
            allTagsList.push(obj);
          });
        }
        this.allTagsList = [];
        const filterKeys = ['domainId','specificLanguage','gender','age'];
        filterKeys.forEach(val => {
          const filterItem = allTagsList.find(item => item.key === val);
          if(filterItem) this.allTagsList.push(filterItem);
        })
        //追加一个收藏
        let collectObj = {
          name: '收藏',
          key: 'favourite',
          data: [
            { key: 'favourite', name: '全部', value: '' },
            { key: 'favourite', name: '收藏', value: 'true' },
            { key: 'favourite', name: '未收藏', value: 'false' },
          ],
        };
        this.allTagsList.push(collectObj);
      } else {
        console.log('---获取发音人失败');
      }
    });
  }
  /**根据条件查询发音人信息 */
  getSpeakerBySearchFn(isLoadMore = false, keyword?: string) {
    if (!isLoadMore) {
      //更换了查询条件
      this.pageNum = 1;
    }
    if (this.totalPages>0 && this.pageNum > this.totalPages) {
      return;
    }
    let queryParam: any = {
      pageNum: this.pageNum,
      pageSize: this.pageSize,
      isGetPackage: false,
      ...this.selectTypeInfo,
    };
    if (keyword) {
      queryParam.keyword = keyword;
    }
    console.log('---queryParam', queryParam);
    this.$http('getSpeakerBySearch', queryParam).then(res => {
      let { totalPages, results, totalElements } = res.data;
      if (keyword) {
        const info = results.find(item => item.speakerId == this.querySpeakerInfo.speakerId)
        if (info) {
          this.setCurrentSpeaker(info)
        }
      } else {
        this.totalPages = totalPages;
        //将风格中的第一个发音人作为默认发音人数据
        if (results.length > 0) {
          results = results.map((item, index) => {
            return {
              ...item,
              defaultSpeaker: item.speakerEmotionCacheVOList[0],
            };
          });
        }
        // 过滤掉音色
        const beforeFilterLen = results.length;
        results = this.filterSpeakerResults(results);
        console.log(1111, results);
        const filteredThisPage = beforeFilterLen - results.length;
        if (!isLoadMore) {
          this.hiddenSpeakerCount = filteredThisPage;
        } else {
          this.hiddenSpeakerCount += filteredThisPage;
        }
        this.totalElements = totalElements - this.hiddenSpeakerCount;
        if (!isLoadMore) {
          this.speakerResults = results;
          localStorage.setItem('speakerList', JSON.stringify(this.speakerResults));
        } else {
          this.speakerResults = this.speakerResults.concat(results);
        }
        this.allSpeakersMap = this.speakerNormalize(this.speakerResults);
      }
     
      console.log('---allSpeakerMap', this.allSpeakersMap, this.speakerResults);
    });
  }
  loadMore() {
    if (this.pageNum >= this.totalPages) {
      return;
    }
    this.pageNum++;
    this.getSpeakerBySearchFn(true);
  }
  handleClickSpeaker(e) {
    if (!this.isApp) {
      console.log('---切换了类型', e);
      this.currSelectIndex = e;
      this.cancelListen();
    }
  }
  handleTouchSpeaker(e) {
    if (this.isApp) {
      console.log('---切换了类型', e);
      this.currSelectIndex = e;
      this.cancelListen();
    }
  }
  chooseItem(e) {
    console.log('---选中了某个', e.value);
    this.selectTypeInfo[e.key] = e.value;
    this.selectTypeInfoTxt[e.key] = e.name;
    console.log('this.selectTypeInfo', e.key,this.selectTypeInfo);
  }
  //重置类型选择里面的某个具体选择
  resetSubType() {
    this.selectTypeInfoTxt[this.allTagsList[this.currSelectIndex].key] = '';
    this.selectTypeInfo[this.allTagsList[this.currSelectIndex].key] = '';
  }
  subSubType() {
    console.log('---点击了确定', this.selectTypeInfo);
    //调用查询
    this.getSpeakerBySearchFn();
    this.currSelectIndex = null;
  }
  resetAllSelect() {
    this.selectTypeInfo = {
      //所有选择的查询条件value
      domainId: '',
      specificLanguage: '',
      gender: '',
      favourite: '',
      age: '',
    };
    this.selectTypeInfoTxt = {
      //所有选择的查询条件name
      domainId: '',
      specificLanguage: '',
      gender: '',
      favourite: '',
      age: '',
    };
    this.subSubType();
  }
  toSearchByName() {
    console.log('---dianjiel');
    this.cancelListen();
    this.showSearchByName = true;
  }
  //点击用TA配音
  useSpeaker() {
    this.cancelListen();
    //设置全局speaker
    console.log(
      '发音人查找页面用它配音',
      this.$store.state.currSpeaker,
      this.$store.state.emotionListMap,
      this.currSpeaker
    );
    //给当前发音人风格赋值
    let speaker = this.currSpeaker;
    if (!speaker) return;
    speaker.speakerEmotionCacheVOList &&
      speaker.speakerEmotionCacheVOList.forEach(item => {
        let moodName = item.speaker.split('@')[1];
        item.moodName = item.name.split('|')[1] || moodName;
        if (moodName) {
          console.log('发音人查找页面用它配音---item', this.$store.state.emotionListMap[moodName]);
          if (this.$store.state.emotionListMap[moodName]) {
            item.moodImg = this.$store.state.emotionListMap[moodName].imageUrl;
          }
        } else {
          // item.moodImg = speaker.headerImage;//test -todo换成默认
          //使用默认头像
          item.moodImg = this.$store.state.emotionListMap['default2']?.imageUrl;
        }
      });
    this.$store.state.currSpeaker = speaker;
    console.log('searchSpeakers useSpeaker', this.$store.state.currSpeaker);
    localStorage.setItem('currSpeaker', JSON.stringify(speaker));
    // let routerName = '/textToVideo';
    // if (this.pageSource === 'videoeditor') {
    //   this.$emit('select-speaker', speaker);
    // } else {
    //   this.$router.push(routerName);
    // }

    this.closeSpeakerPopup();
  }
  //取消试听
  cancelListen() {
    console.log('---寻找发音人页面取消试听');
    if (this.$refs.speakerCards) {
      let speakerCardsRef = this.$refs.speakerCards as any;
      speakerCardsRef.cancelListen();
    }
    if (this.$refs.searchByname) {
      let searchBynameRef = this.$refs.searchByname as any;
      searchBynameRef.byNameCancelListen();
    }
  }
  //记录当前点击的发音人:只有用TA配音时才保存到store
  setCurrentSpeaker(speaker) {
    this.currSpeaker = speaker;
    this.currSpeaker.speakerEmotionCacheVOList.map(item => {
      const moodName = item.speaker.split('@')[1] || 'default2';
      item.moodImg = item.moodImg || this.newYearEmotionListMap[moodName]?.imageUrl
      item.moodName = item.emotionName || this.newYearEmotionListMap[moodName]?.emotionName
      if (item.moodName && item.moodName.indexOf('默认') !== -1) {
        item.moodName = '默认'
      }
    })
    console.log("setCurrentSpeaker", this.currSpeaker)
    // this.cancelListen();
  }
  changeFavourite(speaker) {
    this.$emit('change-favourite', speaker)
  }
  // // 发音人初始化
  speakerNormalize(targetArray = []) {
    let obj: any = {};
    // 发音人本体
    let defaultSpeakerIds = [];
    // 全体发音人
    let allSpeakerIds = [];
    // 全部商店发音人
    // let allStoreSpeakers = []
    // 发音人idMap
    let allSpeakerIdMap: any = {};
    let alLineSpeakerMap: any = {};
    // 声音转换发音人
    // let vcSpeakerList = []
    // 已购发音人
    // let userSpeakerList = []
    // 发音人名字和英文名字的映射 包含“我的”
    let nameToEngNameMap = {};
    // 分类对象
    let typeSpeakerMap: any = {};
    // let userHasSpeakersMap: any = {}
    for (let i = 0; i < targetArray.length; i++) {
      let speaker = targetArray[i];
      alLineSpeakerMap[speaker.speaker] = speaker;
      // 如果list中已经存在，即跳过
      if (allSpeakerIds.indexOf(speaker.speaker) > -1 || speaker.speaker.indexOf('48k') !== -1)
        continue;
      allSpeakerIds.push(speaker.speaker);
      allSpeakerIdMap[speaker.id] = speaker.speaker;

      let speakerMoods = speaker.speaker.split('@');
      let defaultSpeaker = speakerMoods[0];
      let speakerMood = speakerMoods[1] || 'default';
      // if ((speaker.vipAuth == VOICE_AUTH_TYPE.SVIP || speaker.vipAuth == VOICE_AUTH_TYPE.VIP) && (vipType == VIP_TYPE.SVIP || vipType == VIP_TYPE.COMPANY)) {
      //     speaker.usable = true
      // }
      // if (speaker.vipAuth == VOICE_AUTH_TYPE.VIP && vipType == VIP_TYPE.VIP) {
      //     speaker.usable = true
      // }

      // // 已购发音人
      // if (speaker.vipAuth == VOICE_AUTH_TYPE.PAID && (purchasedList.includes(defaultSpeaker) || purchasedList.includes(defaultSpeaker.replace("_lpcnet","_meet"))||purchasedList.includes(defaultSpeaker.replace("_meet","_lpcnet")))) {
      //     speaker.usable = true
      // }
      // 只考虑本体
      if (speakerMoods.length == 1) {
        // 只做24k的映射
        if (!speaker.speaker.includes('48k')) {
          nameToEngNameMap[`${speaker.name}~${speaker.pinyin}～${speaker.pinyinInitial}`] =
            speaker.speaker;
        }
        // 分类归属
        if (Array.isArray(speaker.speakerType)) {
          speaker.speakerType.forEach(type => {
            typeSpeakerMap[type.id] = typeSpeakerMap[type.id] || {};
            typeSpeakerMap[type.id][defaultSpeaker] = 1;
          });
        }

        // 搜集本体
        if (defaultSpeakerIds.indexOf(defaultSpeaker) == -1) {
          defaultSpeakerIds.push(defaultSpeaker);
        }

        // 声音转换发音人筛选-过滤掉48K,防止声音转换时出现两个
        // if (speaker.vcSpeaker && !speaker.speaker.includes('_48k') && vcSpeakerList.indexOf(defaultSpeaker) == -1) {
        //   vcSpeakerList.push(defaultSpeaker)
        // }

        // 已购发音人
        // if (purchasedList.includes(speaker.speaker) && speaker.vipAuth == VOICE_AUTH_TYPE.PAID) {
        //   userSpeakerList.push(defaultSpeaker)
        // }
        //商店发音人
        // if (speaker.vipAuth == VOICE_AUTH_TYPE.PAID) {
        //   allStoreSpeakers.push(defaultSpeaker)
        // }
      }
      // if (speaker.usable == true) {
      //   userHasSpeakersMap[speaker.speaker] = speaker
      // }
      // 风格名称
      speaker.styleName = speaker.name.split('|')[1] || '通用';
      if (obj[`${defaultSpeaker.replace('lpcnet', 'meet')}`]) {
        defaultSpeaker = defaultSpeaker.replace('lpcnet', 'meet');
      } else if (obj[`${defaultSpeaker.replace('meet', 'lpcnet')}`]) {
        defaultSpeaker = defaultSpeaker.replace('meet', 'lpcnet');
      }
      // map构造
      obj[`${defaultSpeaker}`] = obj[`${defaultSpeaker}`] || {};
      let moodsObj = obj[`${defaultSpeaker}`] || {};
      moodsObj[speakerMood] = speaker;
      obj[`${defaultSpeaker}`] = moodsObj;
      alLineSpeakerMap[speaker.speaker] = speaker;
    }
    return {
      allSpeakersMap: obj, //{speaker.speaker:[各个风格的数据]}
    };
  }

  

  closeSpeakerPopup() {
    //结束试听
    this.cancelListen();
    const from = this.$route.query.from;
    if (from && typeof from === 'string') {
      this.$router.replace({ path: from });
    } else if (this.isApp) {
      let unableBack = (<any>window).unableBack;
      console.log('unableBack.postMessage', 'SPEAKER', unableBack)
      unableBack.postMessage('SPEAKER');
    } else {
      this.$navigateBack();
    }
  }

  doLogin() {
    localStorage.setItem('doLogin', 'true');
    this.closeSpeakerPopup();
  }
}
